import { EuiComboBox } from '@equipmentshare/ds2'
import { useComboBoxSearch } from 'components/ComboBox/useComboBoxState'
import useGroupedOptions from './useGroupedOptions'
import { ComboBoxOptionOption, GroupedComboBoxProps } from 'components/ComboBox/types'

export default function GroupedComboBoxEui<T>( {
	setSelectedOption,
	selectedOption,
	data,
	getName,
	setSearchString,
	debounceDelayMs,
	async = true,
	getGroupBy,
	getGroupLabel,
	sortCallback,
	...props
}: GroupedComboBoxProps<T> ) {
	const { setInputVal } = useComboBoxSearch( { setSearchString, debounceDelayMs } )
	const { groups, buildOption } = useGroupedOptions( { data, getName, getGroupBy, getGroupLabel, sortCallback } )

	function handleSearch( search: string ) {
		setInputVal( search )
	}

	function handleSelect( option: ComboBoxOptionOption<T>[] | undefined ) {
		setSelectedOption( option?.[ 0 ] ? option[ 0 ].value : undefined )
	}

	return (
		<EuiComboBox
			placeholder="Search for or select"
			onSearchChange={setSearchString ? handleSearch : undefined}
			options={groups}
			singleSelection={{ asPlainText: true }}
			selectedOptions={selectedOption ? [ buildOption( selectedOption ) ] : []}
			onChange={handleSelect}
			async={async}
			{...props}
		/>
	)
}
